import React, { useEffect, useState } from "react";
import { Container, Box, LinearProgress } from "@mui/material";
import { Card, Typography, useMediaQuery  } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import apiClient from "../api/apiClient";
import { Bar, Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend,LineElement,PointElement,Filler } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels"; 
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { uD } from '../context/DC';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels, PointElement,LineElement,Filler);

const P08001 = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); 
  const [data, setData] = useState({});
  const [dataAll, setDataAll] = useState([]); 
  const [dataBbl, setDataBbl] = useState([]);   
  const [dataKtb, setDataKtb] = useState([]); 
  const [dataKbank, setDataKbank] = useState([]);
  const [dataScb, setDataScb] = useState([]);
  const [dataTtb, setDataTtb] = useState([]);
  const [dataBay, setDataBay] = useState([]);  
  const [dataUob, setDataUob] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [error, setError] = useState(false);
  const [progress, setProgress] = useState(0); 
  const [loading, setLoading] = useState(true); 
  const token = localStorage.getItem("token");
  const { mG } = uD();
  const cs = startDate && dayjs(startDate).isValid() && !loading;

  const fetchConfigData = async (uSD = false) => {
    setLoading(true);
    setError(false);
    setProgress(0); 
    try {

      let preDate;
      if (uSD) {
        if (!startDate || !dayjs(startDate).isValid()) {
          setError(true);
          return;
        }
        preDate = dayjs(startDate).format("YYYY-MM-DD");
      } else {
        preDate = dayjs().subtract(1, 'day').format("YYYY-MM-DD");
      }

      const dataToSend = {
        screen: "ReportCashFlow",
        startdate: preDate
      };

      const response = await apiClient.get("/api-report/banktransaction-summary", {
              headers: { Authorization: `Bearer ${token}` },
              params: dataToSend
            });

      if (response.data.bankAllBalances && response.data.bankAllBalances.length > 0) {

        const bankData = response.data.bankBalances[0];  
        setData(bankData);  
        setDataAll(response.data.bankAllBalances);
        setDataBbl(response.data.bankBblBalances);
        setDataKtb(response.data.bankKtbBalances);
        setDataKbank(response.data.bankKBankBalances);
        setDataScb(response.data.bankScbBalances);
        setDataTtb(response.data.bankTtbBalances);
        setDataBay(response.data.bankBayBalances);
        setDataUob(response.data.bankUobBalances);
      } else {

        if (uSD) {
          await mG({t: "Warning",tc: "#ffa000",m: "ไม่พบข้อมูล กรุณาค้นหาข้อมูลใหม่อีกครั้ง",bt: "OK",btc: "white",bc: "#ffb300",bch: "#ff6f00",}); 
        }
        setData({});  
        setDataAll([]);
        setDataBbl([]);
        setDataKtb([]);
        setDataKbank([]);
        setDataScb([]);
        setDataTtb([]);
        setDataBay([]);
        setDataUob([]);
      }

      setLoading(false);
      setProgress(100); 

    } catch (error) {
      let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    } finally {
      setLoading(false);
      setProgress(100);
    }

  };

  useEffect(() => {
      fetchConfigData(false);
    }, []);

  const cD = () => {
    setData({});  
    setDataAll([]);
    setDataBbl([]);
    setDataKtb([]);
    setDataKbank([]);
    setDataScb([]);
    setDataTtb([]);
    setDataBay([]);
    setDataUob([]);
  };

  const chartData = {
    labels: dataAll.map(bank => bank.bankname), 
    datasets: [
      {
        label: "คงเหลือ",
        data: dataAll.map(bank => bank.balance),
        borderColor: "#888888", 
        borderDash: [5, 5], 
        pointBackgroundColor: dataAll.map(bank => bank.color), 
        pointBorderColor: dataAll.map(bank => bank.color),
        backgroundColor: "rgba(0, 0, 255, 0.2)",
        fill: true,
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "ยอดเงินคงเหลือ",
        color: "#6e6e6e",
        font: {
          size: 14, 
          weight: "bold"
        },
      },
      datalabels: {
        display: false,
      },
      legend: {
        display: false 
      }
    },
    scales: {
      x: {
        display: true, 
        ticks: {
          font: {
            size: 9,
            weight: "bold"
          }
        }
      },
      y: {
        display: false 
      }
    }
  };

  const chartDataBbl = {
    labels: dataBbl.map(item => item.bankname), 
    datasets: [
      {
        label: "",
        data: dataBbl.map(item => item.balance),
        backgroundColor: dataBbl.map(item => item.color), 
        borderColor: dataBbl.map(item => item.color), 
        borderWidth: 1,
        stack: 'stack1'
      }
      ,
      {
        label: "",
        data: dataBbl.map(item => item.od),
        backgroundColor: "#4caf50", 
        borderColor: "#4caf50", 
        borderWidth: 1,
        stack: 'stack1'
      }
    ]
  };

  const chartOptionsBbl = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "ธนาคารกรุงเทพ",
        color: "#6e6e6e",
        font: {
          size: 14, 
          weight: "bold" 
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            if (value === undefined || value === null) return ""; 
            return "฿ " + value.toLocaleString();
          }
        }
      },
      datalabels: {
        display: true,
        color: "#000", 
        font: {
          size: 11
        },
        formatter: (value) => {
          if (value === undefined || value === null) return ""; 
          return "฿ " + value.toLocaleString();
        },
        anchor: 'end', 
        align: 'top',  
        offset: -5,     
      },
      legend: {
        display: false 
      }
    },
    scales: {
      x: {
        display: true, 
        ticks: {
          font: {
            size: 11,
            weight: "bold"
          }
        }
      },
      y: {
        display: false 
      }
    }
  };

  const chartDataKtb = {
    labels: dataKtb.map(item => item.bankname), 
    datasets: [
      {
        label: "",
        data: dataKtb.map(item => item.balance), 
        backgroundColor: dataKtb.map(item => item.color), 
        borderColor: dataKtb.map(item => item.color), 
        borderWidth: 1,
        stack: 'stack1'
      },
      {
        label: "",
        data: dataKtb.map(item => item.od), 
        backgroundColor: "#4caf50", 
        borderColor: "#4caf50", 
        borderWidth: 1,
        stack: 'stack1'
      }
    ]
  };

  const chartOptionsKtb = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "ธนาคารกรุงไทย",
        color: "#6e6e6e",
        font: {
          size: 14, 
          weight: "bold" 
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            if (value === undefined || value === null) return ""; 
            return "฿ " + value.toLocaleString();
          }
        }
      },
      datalabels: {
        display: true,
        color: "#000",
        font: {
          size: 11
        },
        formatter: (value) => {
          if (value === undefined || value === null) return ""; 
          return "฿ " + value.toLocaleString();
        },
        anchor: 'end', 
        align: 'top',  
        offset: -5,     
      },
      legend: {
        display: false 
      }
    },
    scales: {
      x: {
        display: true, 
        ticks: {
          font: {
            size: 11,
            weight: "bold"
          }
        }
      },
      y: {
        display: false 
      }
    }
  };

  const chartDataKbank = {
    labels: dataKbank.map(item => item.bankname), 
    datasets: [
      {
        label: "",
        data: dataKbank.map(item => item.balance), 
        backgroundColor: dataKbank.map(item => item.color), 
        borderColor: dataKbank.map(item => item.color), 
        borderWidth: 1,
        stack: 'stack1'
      },
      {
        label: "",
        data: dataKbank.map(item => item.od), 
        backgroundColor: "#4caf50", 
        borderColor: "#4caf50", 
        borderWidth: 1,
        stack: 'stack1'
      }
    ]
  };

  const chartOptionsKbank = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "ธนาคารกสิกรไทย",
        color: "#6e6e6e",
        font: {
          size: 14, 
          weight: "bold" 
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            if (value === undefined || value === null) return ""; 
            return "฿ " + value.toLocaleString();
          }
        }
      },
      datalabels: {
        display: true,
        color: "#000",
        font: {
          size: 11
        },
        formatter: (value) => {
          if (value === undefined || value === null) return ""; 
          return "฿ " + value.toLocaleString();
        },
        anchor: 'end', 
        align: 'top',
        offset: -5,     
      },
      legend: {
        display: false 
      }
    },
    scales: {
      x: {
        display: true, 
        ticks: {
          font: {
            size: 11,
            weight: "bold"
          }
        }
      },
      y: {
        display: false 
      }
    }
  };

  const chartDataScb = {
    labels: dataScb.map(item => item.bankname), 
    datasets: [
      {
        label: "",
        data: dataScb.map(item => item.balance), 
        backgroundColor: dataScb.map(item => item.color), 
        borderColor: dataScb.map(item => item.color), 
        borderWidth: 1,
        stack: 'stack1'
      },
      {
        label: "",
        data: dataScb.map(item => item.od), 
        backgroundColor: "#4caf50", 
        borderColor: "#4caf50", 
        borderWidth: 1,
        stack: 'stack1'
      }
    ]
  };

  const chartOptionsScb = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "ธนาคารไทยพาณิชย์",
        font: {
          size: 14, 
          weight: "bold" 
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            if (value === undefined || value === null) return ""; 
            return "฿ " + value.toLocaleString();
          }
        }
      },
      datalabels: {
        display: true,
        color: "#000", 
        font: {
          size: 11
        },
        formatter: (value) => {
          if (value === undefined || value === null) return ""; 
          return "฿ " + value.toLocaleString();
        },
        anchor: 'end', 
        align: 'top',  
        offset: -5,     
      },
      legend: {
        display: false 
      }
    },
    scales: {
      x: {
        display: true, 
        ticks: {
          font: {
            size: 11,
            weight: "bold"
          }
        }
      },
      y: {
        display: false
      }
    }
  };

  const chartDataTtb = {
    labels: dataTtb.map(item => item.bankname), 
    datasets: [
      {
        label: "",
        data: dataTtb.map(item => item.balance),
        backgroundColor: dataTtb.map(item => item.color), 
        borderColor: dataTtb.map(item => item.color), 
        borderWidth: 1,
        stack: 'stack1'
      },
      {
        label: "",
        data: dataTtb.map(item => item.od), 
        backgroundColor: "#4caf50",
        borderColor: "#4caf50", 
        borderWidth: 1,
        stack: 'stack1'
      }

    ]
  };

  const chartOptionsTtb = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "ธนาคารทหารไทยธนชาต",
        font: {
          size: 14, 
          weight: "bold" 
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            if (value === undefined || value === null) return ""; 
            return "฿ " + value.toLocaleString();
          }
        }
      },
      datalabels: {
        display: true,
        color: "#000", 
        font: {
          size: 11
        },
        formatter: (value) => {
          if (value === undefined || value === null) return ""; 
          return "฿ " + value.toLocaleString();
        },
        anchor: 'end', 
        align: 'top',
        offset: -5,     
      },
      legend: {
        display: false 
      }
    },
    scales: {
      x: {
        stacked: true,
        display: true, 
        ticks: {
          font: {
            size: 11,
            weight: "bold"
          }
        }
      },
      y: {
        stacked: true,
        display: false, 
        ticks: {
          callback: (value) => '฿ ' + value.toLocaleString()
        }
      }
    }
  };

  const chartDataBay = {
    labels: dataBay.map(item => item.bankname),
    datasets: [
      {
        label: "",
        data: dataBay.map(item => item.balance), 
        backgroundColor: dataBay.map(item => item.color), 
        borderColor: dataBay.map(item => item.color), 
        borderWidth: 1,
        stack: 'stack1'
      },
      {
        label: "",
        data: dataBay.map(item => item.od), 
        backgroundColor: "#4caf50", 
        borderColor: "#4caf50", 
        borderWidth: 1,
        stack: 'stack1'
      }
    ]
  };

  const chartOptionsBay = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "ธนาคารกรุงศรีอยุธยา",
        color: "#6e6e6e",
        font: {
          size: 14, 
          weight: "bold" 
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            if (value === undefined || value === null) return ""; 
            return "฿ " + value.toLocaleString();
          }
        }
      },
      datalabels: {
        display: true,
        color: "#000",
        font: {
          size: 11
        },
        formatter: (value) => {
          if (value === undefined || value === null) return ""; 
          return "฿ " + value.toLocaleString();
        },
        anchor: 'end',
        align: 'top', 
        offset: -5,    
      },
      legend: {
        display: false 
      }
    },
    scales: {
      x: {
        display: true, 
        ticks: {
          font: {
            size: 11,
            weight: "bold"
          }
        }
      },
      y: {
        display: false 
      }
    }
  };

const chartDataUob = {
  labels: dataUob.map(item => item.bankname), 
  datasets: [
    {
      label: "",
      data: dataUob.map(item => item.balance), 
      backgroundColor: dataUob.map(item => item.color), 
      borderColor: dataUob.map(item => item.color), 
      bborderWidth: 1,
        stack: 'stack1'
    },
      {
        label: "",
        data: dataUob.map(item => item.od), 
        backgroundColor: "#4caf50", 
        borderColor: "#4caf50", 
        borderWidth: 1,
        stack: 'stack1'
      }
  ]
};

const chartOptionsUob = {
  responsive: true,
  plugins: {
    title: {
      display: true,
      text: "ธนาคารยูโอบี",
      font: {
        size: 14,
        weight: "bold" 
      },
    },
    tooltip: {
      callbacks: {
          label: function (context) {
            const value = context.raw;
            if (value === undefined || value === null) return ""; 
            return "฿ " + value.toLocaleString();
          }
      }
    },
    datalabels: {
      display: true,
      color: "#000", 
      font: {
        size: 11
      },
        formatter: (value) => {
          if (value === undefined || value === null) return ""; 
          return "฿ " + value.toLocaleString();
        },
      anchor: 'end', 
      align: 'top',
      offset: -5,   
    },
    legend: {
      display: false 
    }
  },
  scales: {
    x: {
      display: true,
      ticks: {
        font: {
          size: 11,
          weight: "bold"
        }
      }
    },
    y: {
      display: false 
    }
  }
};

  return (
    <Container component="main" maxWidth="96%" sx={{marginTop: "40px",border: "0px solid #e0e0e0",boxSizing: "border-box",}}>
      {loading ? (
        <Box sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <LinearProgress variant="determinate" value={progress} sx={{ width: '50%' }} />
        </Box>

        ) : ( 

      <Box sx={{ width: '100%',display: "flex",flexDirection: "column", marginLeft:0, marginBottom:0, boxShadow: "none",marginTop: "0px",border: "0px solid #e0e0e0" ,boxSizing: "border-box",
        backgroundColor: "background.paper",
      }}>

      {loading && (
          <Box sx={{ width: '50%', marginBottom: '20px',textAlign: "center",
            verticalAlign: "middle",padding:1 }}>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
      )}
  
        <Box sx={{ borderRadius: 0,boxSizing: "border-box",marginBottom:0, boxShadow: "none",marginTop: "0px",
          textAlign: "center",
          verticalAlign: "middle",
          padding:1,
          backgroundColor: "#f5f5f5",
          fontSize: "calc(14px + 0.5vw)",
          fontWeight: "bold",
          color: "#333",
        }}>
          รายงานภาพรวมกระแสเงินสด (Cash Flow Summary)
        </Box>
       
        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
            borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
            display: "flex",         
            justifyContent: "center",   
            alignItems: "center",
            gap: 2, flexWrap: "wrap",
          }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>        
                <DatePicker label="เลือกวันที่*"
                            value={startDate}
                            onChange={(newValue) => {
                              setStartDate(newValue);
                              setError(false);
                              cD();
                            }}
                            sx={{ width: 190 }}
                            slotProps={{
                              field: { clearable: true, onClear: () => setStartDate(null) },
                              textField: { 
                                size: 'small',
                                placeholder: 'Select Date',
                                error: error,
                                helperText: error && !startDate ? 'กรุณาเลือกวัน' : '',
                              },
                            }}
                            
                          />
            </LocalizationProvider>

              <button
                onClick={() => {
                  if (!startDate || !dayjs(startDate).isValid()) {
                    setError(true);
                    return;
                  }
                  fetchConfigData(true);
                }}
                disabled={!cs}
                style={{
                  padding: "8px 15px",
                  background: "#0061d4",
                  color: "white",
                  border: "none",
                  cursor: !cs ? "not-allowed" : "pointer",
                  fontSize: "calc(8px + 0.5vw)",
                  marginRight: "10px",
                  opacity: !cs ? 0.6 : 1,
                }}
              >
                แสดงข้อมูล
            </button>


        </Box>

{dataAll.length <= 0 && (
        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "0px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
          borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
        }}>
              "กรุณาเลือกวันที่แล้วคลิกแสดงข้อมูล"
        </Box>
        )}

{/*  Body */}  
{dataAll.length > 0 && (  

        <Box sx={{  marginBottom:"0px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
          borderRadius: 0,

          display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 1,
          padding:1,
        }}>

          <Card sx={{ width: isSmallScreen ? "100%" : "30%",height: "70px", textAlign: "center" ,padding: 0 ,}}>
            <Typography variant="subtitle1" sx={{ fontSize: "calc(14px + 0.3vw)",fontWeight: "bold", marginBottom: 1, color: "#6e6e6e" }}>เงินสดคงเหลือ</Typography>
            <Typography variant="h4" sx={{ fontSize: "calc(14px + 1vw)",fontWeight: "bold", color: "#09d146" }}>
              {new Intl.NumberFormat("th-TH", { style: "currency", currency: "THB" }).format(data.netprofit)}
            </Typography>
          </Card>

          <Card sx={{ width: isSmallScreen ? "100%" : "30%",height: "70px", textAlign: "center" ,padding: 0 ,}}>
            <Typography variant="subtitle1" sx={{ fontSize: "calc(14px + 0.3vw)",fontWeight: "bold", marginBottom: 1, color: "#6e6e6e" }}>เงินนำฝากเข้าบัญชี</Typography>
            <Typography variant="h4" sx={{ fontSize: "calc(14px + 1vw)",fontWeight: "bold", color: "#007ef6" }}>
              {new Intl.NumberFormat("th-TH", { style: "currency", currency: "THB" }).format(data.totalrevenue)}
            </Typography>
          </Card>

          <Card sx={{ width: isSmallScreen ? "100%" : "30%",height: "70px", textAlign: "center" ,padding: 0 ,}}>
            <Typography variant="subtitle1" sx={{ fontSize: "calc(14px + 0.3vw)",fontWeight: "bold", marginBottom: 1, color: "#6e6e6e" }}>เงินหักบัญชี</Typography>
            <Typography variant="h4" sx={{ fontSize: "calc(14px + 1vw)",fontWeight: "bold", color: "#e65151" }}>
              {new Intl.NumberFormat("th-TH", { style: "currency", currency: "THB" }).format(data.totalexpenses)}
            </Typography>
          </Card>

          <Box sx={{ width: "100%", marginBottom:"0px", boxShadow: "none",marginTop: "0px" ,boxSizing: "border-box",
          borderRadius: 0,
          display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 0,
          padding:0,}} />

          <Card sx={{ width: isSmallScreen ? "100%" : "30%",height: "150px", textAlign: "center",
            display: "flex",           
            alignItems: "center",      
            justifyContent: "center",   
            padding: 0                 
          }}>
            <Line data={chartData} options={chartOptions} />
          </Card>

          <Card sx={{ width: isSmallScreen ? "100%" : "30%",height: "150px", textAlign: "center",
            display: "flex",           
            alignItems: "center",      
            justifyContent: "center",   
            padding: 0                 
          }}>
            <Bar data={chartDataBbl} options={chartOptionsBbl} />
          </Card>

          <Card sx={{ width: isSmallScreen ? "100%" : "30%",height: "150px", textAlign: "center",
            display: "flex",           
            alignItems: "center",      
            justifyContent: "center",   
            padding: 0                 
          }}>
            <Bar data={chartDataKtb} options={chartOptionsKtb} />
          </Card>

          <Box sx={{ width: "100%", marginBottom:"0px", boxShadow: "none",marginTop: "0px" ,boxSizing: "border-box",
          borderRadius: 0,
          display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 0,
          padding:0,}} />

          <Card sx={{ width: isSmallScreen ? "100%" : "30%",height: "150px", textAlign: "center",
            display: "flex",           
            alignItems: "center",      
            justifyContent: "center",   
            padding: 0                 
          }}>
            <Bar data={chartDataKbank} options={chartOptionsKbank} />
          </Card>

          <Card sx={{ width: isSmallScreen ? "100%" : "30%",height: "150px", textAlign: "center",
              display: "flex",           
              alignItems: "center",       
              justifyContent: "center",   
              padding: 0                  
            }}>
              <Bar data={chartDataScb} options={chartOptionsScb} />
          </Card>

          <Card sx={{ width: isSmallScreen ? "100%" : "30%",height: "150px", textAlign: "center",
              display: "flex",           
              alignItems: "center",       
              justifyContent: "center",   
              padding: 0               
            }}>
              <Bar data={chartDataTtb} options={chartOptionsTtb} />
          </Card>

          <Box sx={{ width: "100%", marginBottom:"0px", boxShadow: "none",marginTop: "0px" ,boxSizing: "border-box",
          borderRadius: 0,
          display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 0,
          padding:0,}} />

          <Card sx={{ width: isSmallScreen ? "100%" : "30%",height: "150px", textAlign: "center",
            display: "flex",           
            alignItems: "center",      
            justifyContent: "center",   
            padding: 0                 
          }}>
            <Bar data={chartDataBay} options={chartOptionsBay} />
          </Card>

          <Card sx={{ width: isSmallScreen ? "100%" : "30%",height: "150px", textAlign: "center",
            display: "flex",           
            alignItems: "center",      
            justifyContent: "center",   
            padding: 0                 
          }}>
            <Bar data={chartDataUob} options={chartOptionsUob} />
          </Card>

        </Box>
        
        )} 

      </Box>
      
      )}

    </Container>
  );
};

export default P08001;